var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"page"},[_c('h1',[_vm._v("我的笔记")]),_c('p',{staticClass:"muted"},[_vm._v("集中管理你的 AI 学习记录")]),_c('div',{staticClass:"list"},_vm._l((_vm.notes),function(n){return _c('article',{key:n.id},[_c('b',[_vm._v(_vm._s(n.topic))]),_c('span',[_vm._v(_vm._s(n.model||'通义千问 2.5'))]),_c('p',[_vm._v(_vm._s(n.summary))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }